import cx from "classnames";
import React from "react";
import { Paragraph } from "@trainline/depot-web";
import IconTransportMode from "../IconTransportMode";
import * as s from "./CarrierInformation.module.css";
const CarrierInformation = ({
  className,
  name,
  identifier,
  type,
  transportDesignation,
  timetableId,
  displayTimetableId,
  route = ""
}) => /* @__PURE__ */ React.createElement("div", {
  className: cx(s.carrierInformation, className)
}, type && /* @__PURE__ */ React.createElement(IconTransportMode, {
  type,
  width: "24",
  color: "var(--dp_brand_neutral_dark)"
}), name && /* @__PURE__ */ React.createElement(Paragraph, {
  as: "span",
  color: "subtle",
  className: s.name
}, name, !!transportDesignation && ` ${transportDesignation}`, !!route && ` ${route}`, displayTimetableId && !!timetableId && ` ${timetableId}`), identifier && /* @__PURE__ */ React.createElement(Paragraph, {
  as: "span",
  typeStyle: "mini",
  color: "subdued"
}, identifier));
var CarrierInformation_default = CarrierInformation;
export {
  CarrierInformation_default as default
};
